module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_0.a9ce4234.png";